import { useEffect, useRef } from 'react';

export function useInitialized<T = unknown>(callback: (data: NonNullable<T>) => unknown, data?: T) {
  const isConstructorCalled = useRef(false);

  useEffect(() => {
    if (!isConstructorCalled.current && data) {
      callback(data as NonNullable<T>);
      isConstructorCalled.current = true;
    }
  }, [callback, data]);
}
